import type {
  ThemeColorsBackground,
  ThemeColorsBorder,
  ThemeColorsMeta,
  ThemeColorsMetaIcon,
  ThemeColorsText,
} from '@frameio/vapor-theme';
import { theme } from '@frameio/vapor-theme';

function isInteractiveTextKey(
  color: ThemeColorsText
): color is keyof typeof theme.colors.text.interactive {
  return color in theme.colors.text.interactive;
}

export function getTextColor(color: ThemeColorsText) {
  if (isInteractiveTextKey(color)) {
    return theme.colors.text.interactive[color];
  }
  return theme.colors.text[color];
}

function isInteractiveBackgroundKey(
  color: ThemeColorsBackground
): color is keyof typeof theme.colors.background.interactive {
  return (
    color !== 'transparent' && color in theme.colors.background.interactive
  );
}

export function getBackgroundColor(color: ThemeColorsBackground) {
  if (color === 'transparent') return color;
  if (isInteractiveBackgroundKey(color)) {
    return theme.colors.background.interactive[color];
  }
  return theme.colors.background[color];
}

function isInteractiveBorderKey(
  color: ThemeColorsBorder
): color is keyof typeof theme.colors.border.interactive {
  return color in theme.colors.border.interactive;
}

export function getBorderColor(color: ThemeColorsBorder) {
  if (color === 'transparent') return color;
  if (isInteractiveBorderKey(color)) {
    return theme.colors.border.interactive[color];
  }
  return theme.colors.border[color];
}

export function getMetaTextColor(color: ThemeColorsMeta) {
  if (!color || !(color in theme.colors.meta.opaque)) {
    return theme.colors.text.body;
  }
  if (color === 'default') {
    return theme.colors.text.body;
  }
  return theme.colors.meta.text[color];
}

export function getMetaIconColor(color: ThemeColorsMetaIcon) {
  return theme.colors.meta.icon[color];
}
